const initialState = {
    approved: [], 
    applied:[],
    
  
  };
  
  const SupApplicationsReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_APPROVED_SUCCESS':
            return {... state, approved:action.payload};
            case 'FETCH_APPLIED_SUCCESS':
            return {... state, applied:action.payload};
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SupApplicationsReducers;
  
  